// eslint-disable-next-line no-unused-vars
import React from 'react';
import {FaInfoCircle, FaPlayCircle, FaUsers, FaEnvelope} from 'react-icons/fa';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FooterContainer = styled.footer`
  text-align: center;
  margin: 0 auto;
  background-image: url('/assets/ui/footer.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  font-size: 10pt;
  padding-bottom: 10px;
`;

const Wrapper = styled.div`
  max-width: 1200px;
  margin: auto;
  padding: 0 20px;
`;

const FooterMenu = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const FooterBlock = styled.div`
  flex: 1;
  min-width: 200px;
  padding: 10px;
`;

const Title = styled.div`
  color: white;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  border-bottom: 2px solid #4e0101;
  padding-bottom: 5px;
`;

const MenuList = styled.ul`
  list-style: none;
  padding: 0;
`;

const MenuItem = styled.li`
  margin-bottom: 5px;
`;

const StyledLink = styled(Link)`
  color: #b8b8b8;
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: #4e0101;
  }
`;


const FooterLine = styled.div`
  border-top: 1px solid #444;
  margin: 10px 0;
`;

const FooterInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #b8b8b8;
  font-size: 14px;
  opacity: 0.8;
  padding: 20px;
  height: 50px;
`;

const CopyrightText = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  height: 100%;
`;


const StyledSpan = styled.span`
  color: #f30d34;
  padding: 0 5px;
`;

const FooterLogo = styled.img`
  width: 130px;
  height: 30px;
`;

const Footer = () => {
  const { t } = useTranslation();

  const handleFooterClick = () => {
    sessionStorage.setItem("fromFooterClick", "true");
  };

  const DiscordUrl = process.env.REACT_APP_DISCORD_URL;

  return (
    <FooterContainer>
      <Wrapper>
        <FooterMenu>
          <FooterBlock>
            <Title>
              <FaInfoCircle /> {t('footer.information')}
            </Title>
            <MenuList>
              <MenuItem>
                <StyledLink to="/privacy-policy" onClick={handleFooterClick}>
                  {t('footer.privacyPolicy')}
                </StyledLink>
              </MenuItem>
              <MenuItem>
                <StyledLink to="/terms-of-service" onClick={handleFooterClick}>
                  {t('footer.termsOfService')}
                </StyledLink>
              </MenuItem>
              <MenuItem>
                <StyledLink to="/refund-policy" onClick={handleFooterClick}>
                  {t('footer.refundPolicy')}
                </StyledLink>
              </MenuItem>
            </MenuList>
          </FooterBlock>
          <FooterBlock>
            <Title>
              <FaPlayCircle /> {t('footer.howToStart')}
            </Title>
            <MenuList>
              <MenuItem>
                <StyledLink to="/register" onClick={handleFooterClick}>
                  {t('footer.register')}
                </StyledLink>
              </MenuItem>
              <MenuItem>
                <StyledLink to="/download" onClick={handleFooterClick}>
                  {t('footer.download')}
                </StyledLink>
              </MenuItem>
              <MenuItem>
                <StyledLink to="/wiki" onClick={handleFooterClick}>
                  {t('footer.wiki')}
                </StyledLink>
              </MenuItem>
            </MenuList>
          </FooterBlock>
          <FooterBlock>
            <Title>
              <FaUsers /> {t('footer.community')}
            </Title>
            <MenuList>
              <MenuItem>
                <StyledLink to="/ranking" onClick={handleFooterClick}>
                  {t('footer.ranking')}
                </StyledLink>
              </MenuItem>
              <MenuItem>
                <StyledLink as="a" href={DiscordUrl} target="_blank" rel="noopener noreferrer">
                  {t('footer.discord')}
                </StyledLink>
              </MenuItem>
              <MenuItem>
                <StyledLink
                  as="a"
                  href="https://www.elitepvpers.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('footer.elitePvPers')}
                </StyledLink>
              </MenuItem>
            </MenuList>
          </FooterBlock>
          <FooterBlock>
            <Title>
              <FaEnvelope /> {t('footer.support')}
            </Title>
            <MenuList>
              <MenuItem>
                <StyledLink to="/support" onClick={handleFooterClick}>
                  {t('footer.supportLink')}
                </StyledLink>
              </MenuItem>
            </MenuList>
          </FooterBlock>
        </FooterMenu>
        <FooterLine />
        <FooterInfo>
          <CopyrightText>
            Copyright © 2025<StyledSpan>Arcane</StyledSpan> {t('footer.allRightsReserved')}
          </CopyrightText>
          <FooterLogo src="/assets/logo/logo.png" alt="Logo" />
        </FooterInfo>
      </Wrapper>
    </FooterContainer>
  );
};

export default Footer;
